import Model from '@/store/plugins/orm/Model';
import { ReceptionItem } from './ModelRepository';
import i18n from '@/i18n';

export class Reception extends Model {
    static get entity () {
        return 'receptions'
    }

    static fields () {
        return {
            id: this.attr(null),
            number: this.attr(null),
            date: this.attr(null),
            client_id: this.attr(null),
            storekeeper: this.attr(null),
            comment: this.attr(null),
            items: this.attr([], value => value.map(item => new ReceptionItem(item))),

            client: this.attr(null),
        }
    }

    toTextLines() {
        const venue = this.$store().getters.tenant?.venue;
        if(!venue) return [];

        const lines = [];

        lines.push(`[HR]`);
        lines.push(`[C][H22]${i18n.t('general.reception')}`);
        lines.push(`[HR]`);
        lines.push(`[L]`);
        lines.push(`[L]${i18n.t('general.number')}: ${this.number}[R]${venue.name}`);
        lines.push(`[L]${i18n.t('general.date')}: ${moment(this.date).format('DD.MM.YYYY.')}[R]${i18n.t('general.tax_id_number')}: ${venue.tax_id_number}`);
        lines.push(`[L]${i18n.t('general.received_by')}: ${this.storekeeper}[R]${venue.name}`);
        lines.push(`[L]${i18n.tc('general.supplier', 1)}: ${this.client?.name || ''}`)

        if(this.comment) {
            lines.push(`[L]${i18n.t('general.comment')}: ${this.comment}`);
        }

        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);
        lines.push(`[L]`);

        lines.push(`[HR]`);
        lines.push(
            `[L][H00]${i18n.t('general.number')}` +
            `[L]${i18n.t('general.code')}` +
            `[L]${i18n.t('general.inventory_item')}` +
            `[R]${i18n.t('general.quantity')}`
        );
        lines.push(`[HR]`);

        this.items.forEach((item, index) => {
            lines.push(
                `[L][H00]${index + 1}` +
                `[L]${item.getProduct() && item.getProduct().code ? item.getProduct().code : ''}` +
                `[L]${item.getProduct() ? item.getProduct().name : ''}` +
                `[R]${item.getCount()} ${item.getProduct().getUnitOfMeasureSold() || item.getProduct().getUnitOfMeasure()}`
            );
        })
        lines.push(`[HR]`);

        return lines;
    }
}

export default Reception
